/**
 * ロールシステム関連の定数定義
 */

// システムタイプ
export const SYSTEM_TYPES = {
  FBS: 'FBS',
  PORTAL: 'PORTAL',
} as const;

export type SystemType = typeof SYSTEM_TYPES[keyof typeof SYSTEM_TYPES];

export interface Permissions {
  menus: {
    scheduler: boolean;
    job: boolean;
    settings: boolean;
    home: boolean;
    sitemap: boolean;
  };
}

interface StandardRoles {
  ENABLE_ALL: {
    permissions: Permissions;
  };
}

// 標準ロール定義
export const STANDARD_ROLES: StandardRoles = {
  ENABLE_ALL: {
    permissions: {
      menus: {
        scheduler: true,
        job: true,
        settings: true,
        home: true,
        sitemap: true,
      },
    },
  },
};

// 権限関連のキー
export const PERMISSION_KEYS = {
  MENUS: {
    SCHEDULER: 'scheduler',
    JOB: 'job',
    SETTINGS: 'settings',
    HOME: 'home',
    SITEMAP: 'sitemap',
  },
} as const;

export type MenuKey = typeof PERMISSION_KEYS.MENUS[keyof typeof PERMISSION_KEYS.MENUS];
